import { i18n as i18nSetup } from '@nora-monorepo/ui-shared';

const { d } = i18nSetup.global;

export function getRelativeTimestamp(inputDate: Date): string {
  const currentDate = new Date();

  const inputDayStart = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate(),
  );

  const currentDayStart = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
  );

  const oneDayInMillis = 24 * 60 * 60 * 1000;
  const oneYearInMillis = 365 * 24 * 60 * 60 * 1000;

  if (currentDayStart.getTime() - inputDayStart.getTime() < oneDayInMillis) {
    return d(inputDate, 'time');
  }
  else if (currentDate.getTime() - inputDate.getTime() <= oneYearInMillis) {
    return d(inputDate, 'short');
  }
  else {
    return d(inputDate, 'date');
  }
}
